var map = {
	"./index.js": 5005,
	"./nullLoader.js": 9701,
	"./objLoader.js": 3248,
	"./stlLoader.js": 3160,
	"3d/lib/loaders/index.js": 5005,
	"3d/lib/loaders/nullLoader.js": 9701,
	"3d/lib/loaders/objLoader.js": 3248,
	"3d/lib/loaders/stlLoader.js": 3160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4986;